<template>
    <div>
        <b-row class="justify-content-center mt-3">
            <b-button
                class="mr-5"
                variant="outline-secondary"
                @click.stop="cancelPayment"
            >
                <fa-icon fixed-width size="lg" :icon="['fal', 'arrow-from-right']" />
                Cancel
            </b-button>

            <b-button
                id="popover-pay-button"
                variant="outline-success"
                :loading="isPaying"
                :disabled="isInvalidPayment"
                @click.stop="showPayPopover('popover-pay-button')"
            >
                <span class="pr-3">
                    <fa-layers>
                        <fa-icon fixed-width size="lg" :icon="['fal', 'money-check']" />
                        <fa-icon transform="right-15 up-7" :icon="['fas', 'check']" />
                    </fa-layers>
                </span>
                Pay
            </b-button>
        </b-row>

        <slot name="popover">
            <!-- Pay Purchase Pop -->
            <b-popover :target="'popover-pay-button'">
                <template slot="title" class="title-class">
                    <strong>Confirm Payment</strong>
                </template>
                <template slot="default">
                    <b-form-row>
                        <b-col>
                            <p>
                                Click the <strong>Pay</strong> button, if you are ready to mark this
                                Purchase as Paid and notify the applicant.
                            </p>
                        </b-col>
                    </b-form-row>
                </template>
                <b-form-row>
                    <b-col ref="payButton" cols="6">
                        <b-button
                            size="sm"
                            block
                            class="cancel-button"
                            @click="cancelPayment"
                        >
                            <strong>Cancel</strong>
                        </b-button>
                    </b-col>
                    <b-col cols="6">
                        <b-button size="sm"
                                  block
                                  variant="success"
                                  @click="confirmPayment"
                        >
                            <strong>Pay</strong>
                        </b-button>
                    </b-col>
                </b-form-row>
            </b-popover>
        </slot>
    </div>
</template>

<script>
// TODO: Change this to use confirmableActionPopover component
export default {
    name: 'PaymentFormActions',

    props: {
        isInvalidPayment: { type: Boolean, default: false },
        isPaying: { type: Boolean, default: false },
    },

    methods: {
        cancelPayment($event) {
            this.$emit('cancel-payment', $event);
            this.$root.$emit('bv::hide::popover');
        },

        confirmPayment($event) {
            this.$emit('confirm-payment', $event);
            this.$root.$emit('bv::hide::popover');
        },

        showPayPopover(target) {
            this.$root.$emit('bv::hide::popover', target);
            this.$root.$emit('bv::show::popover', target);
        },

        closePayPopover(target) {
            // this.$emit('cancel-payment', target);
            this.$root.$emit('bv::hide::popover', target);
        },
    }
};
</script>
